// reports
import AdminPayment from '../../pages/adminPayment/AdminPayment';
import BusinessSummaryReport from '../../pages/reports/BusinessSummaryReport';
import CommissionReport from '../../pages/reports/CommissionReport';
import FollowupReport from '../../pages/reports/FollowupReport';
import BookingReport from '../../pages/reports/BookingReport';
import BookingCommission from '../../pages/reports/BookingCommission';
import BookingReceipt from '../../pages/reports/BookingReceipt';
import CustomerLedger from '../../pages/reports/CustomerLedger';
import AssociateLedger from '../../pages/reports/AssociateLegder';
import TDS from '../../pages/reports/TDS';
import BranchWiseSummary from '../../pages/reports/BranchWiseSummary';
import BranchSummaryDetails from '../../pages/reports/BranchSummaryDetails';
import LeadReport from '../../pages/reports/LeadReport';
import EMIReport from '../../pages/reports/EMIReport';
import CancelReport from '../../pages/reports/CancelReport';
import ProjectReport from '../../pages/reports/ProjectReport';
import VisitSiteReport from '../../pages/reports/VisitSiteReport';

// Green Energy Management
import WorkFlow from '../../pages/GreenEnergyManagement/master/WorkFlow';
import Capacity from '../../pages/GreenEnergyManagement/master/Capacity';
import Brand from '../../pages/GreenEnergyManagement/master/Brand';
import InstallationType from '../../pages/GreenEnergyManagement/master/InstallationType';
import ChargerType from '../../pages/GreenEnergyManagement/master/ChargerType';
import CreateProjectOrder from '../../pages/GreenEnergyManagement/order/CreateProjectOrder';
import AssignTeam from '../../pages/GreenEnergyManagement/order/AssignTeam';
import ProgressTracking from '../../pages/GreenEnergyManagement/order/ProgressTracking';
import Documents from '../../pages/GreenEnergyManagement/order/Documents';
import GreenEnergyProjectReport from '../../pages/GreenEnergyManagement/order/ProjectReport';
import AddAttachment from '../../pages/GreenEnergyManagement/order/AddAttachment';
import ServiceRequestList from '../../pages/GreenEnergyManagement/installation/ServiceRequestList';
import AssignTechnicianInstallation from '../../pages/GreenEnergyManagement/installation/AssignTechnician';
import InstallationStatus from '../../pages/GreenEnergyManagement/installation/InstallationStatus';
import AMCSchedule from '../../pages/GreenEnergyManagement/installation/AMCSchedule';
import AMCScheduleCreate from '../../pages/GreenEnergyManagement/installation/AMCScheduleCreate';
import ServiceFeedback from '../../pages/GreenEnergyManagement/installation/ServiceFeedback';

import React, { useEffect } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import classnames from 'classnames';

import SettingsIcon from '@mui/icons-material/Settings';
import GithubIcon from '@mui/icons-material/GitHub';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';

import {
  Fab,
  IconButton,
  Box,
  Paper,
  Typography as MuiTypography,
  Button as MuiButton,
  Avatar
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { connect } from 'react-redux';
// styles
import useStyles from './styles';

// components
import Header from '../Header';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import { Link } from '../Wrappers';
import ColorChangeThemePopper from './components/ColorChangeThemePopper';
import { useAuth } from '../../context/AuthContext';
import OTPVerificationModal from '../OTPVerificationModal/OTPVerificationModal';

import EditUser from '../../pages/user/EditUser';

// pages
// import Dashboard from '../../pages/dashboard';
import Dashboard from '../../pages/dashboard/Dashboard';

import GeneralMaster from '../../pages/generalMaster/GeneralMaster';
import RewardSetting from '../../pages/setting/RewardSetting';
import CommissionSetting from '../../pages/setting/CommissionSetting';
import IncentiveSetting from '../../pages/setting/IncentiveSetting';
import LevelStructure from '../../pages/setting/LevelStructure';
import MyRewardIncentive from '../../pages/Achievements/MyRewardIncentive';



// Organization Master
import Policy from '../../pages/organizationMaster/policy/Policy';
import OrganizationProfile from '../../pages/organizationMaster/organizationProfile/OrganizationProfile';
import DesignationSetup from '../../pages/organizationMaster/designationSetup/DesignationSetup';
import DepartmentSetup from '../../pages/organizationMaster/departmentSetup/DepartmentSetup';
import BusinessSetup from '../../pages/organizationMaster/business/Business';
import BranchSetup from '../../pages/organizationMaster/branchSetup/BranchSetup';

// import Profile from '../../pages/profile/Profile';
import MyProfile from '../../pages/profile/MyProfile';
import MyBusiness from '../../pages/profile/MyBusiness';
import ChangeSponsor from '../../pages/profile/ChangeSponsor';
import KYCApproval from '../../pages/profile/KYCApproval';
import MyHistory from '../../pages/profile/MyHistory';

// Lead
import LeadList from '../../pages/lead/LeadList';
import AddLead from '../../pages/lead/AddLead';
import EditLead from '../../pages/lead/EditLead';
import AddVisit from '../../pages/lead/AddVisit';
import LeadTimeLine from '../../pages/lead/LeadTimeLine';
import ChangeAssociate from '../../pages/lead/changeAssociate/ChangeAssociate';
import TransferHistory from '../../pages/lead/changeAssociate/TransferHistory';
import TransferProcess from '../../pages/lead/changeAssociate/TransferProcess';

// Site Visit
import SiteVisit from '../../pages/siteVisit/SiteVisit';
import AddSiteVisit from '../../pages/siteVisit/AddSiteVisit';
import SiteVisitTimeline from '../../pages/siteVisit/SiteVisitTimeline';

// Project
import ProjectList from '../../pages/project/projectList/ProjectList';
import ProjectForm from '../../pages/project/projectList/ProjectForm';
import ProjectDetails from '../../pages/project/projectList/ProjectDetails';
import PlotListDetails from '../../pages/project/PlotListDetails';
import PlotForm from '../../pages/project/PlotForm';
import RowHouse from '../../pages/project/RowHouse';

// Apartment
import ApartmentForm from '../../pages/project/apartmentList/ApartmentForm';
import ApartmentEdit from '../../pages/project/apartmentList/ApartmentEdit';
import ApartmentDetails from '../../pages/project/apartmentList/ApartmentDetails';

import PlotInventory from '../../pages/project/PlotInventory';
import ProjectPricing from '../../pages/project/apartmentList/ApartmentList';
import BuildingList from '../../pages/project/apartmentList/BuildingList';
import FloorList from '../../pages/project/apartmentList/FloorList';
import FlatList from '../../pages/project/apartmentList/FlatList';
import ProjectEnquiry from '../../pages/project/villa/Villa';
import VillaForm from '../../pages/project/villa/VillaForm';
import RowHouseForm from '../../pages/project/rowhouse/RowHouseForm';
import BuildingForm from '../../pages/project/apartmentList/BuildingForm';
import FloorForm from '../../pages/project/apartmentList/FloorForm';
import FlatForm from '../../pages/project/apartmentList/FlatForm';

// Inventory
import Inventory from '../../pages/inventory/Inventory';

// Reward
import RewardList from '../../pages/reward/RewardList';
import AddReward from '../../pages/reward/AddReward';
import RedeemRequests from '../../pages/reward/RedeemRequests';
import RewardSettings from '../../pages/reward/RewardSettings';
import RewardCatorgy from '../../pages/reward/RewardCatorgy';
import HistoryReward from '../../pages/reward/HistoryReward';
import AssociateReward from '../../pages/reward/AssociateReward';
import RewardTransaction from '../../pages/reward/RewardTransaction';
import LevelAward from '../../pages/PromotionManagement/levelReward/LevelAward';
import Incentive from '../../pages/PromotionManagement/levelReward/Incentive';
import RewardApprove from '../../pages/PromotionManagement/levelReward/RewardApprove';
import IncentiveApprove from '../../pages/PromotionManagement/levelReward/IncentiveApprove';
import PromotionRewardList from '../../pages/PromotionManagement/RewardList';

import AssociateList from '../../pages/associateRegistration/AssociateList';
import AssociateListEditable from '../../pages/associateRegistration/AssociateListEditable';
import AssociateRegistration from '../../pages/associateRegistration/AssociateRegistration';
import AssociateTree from '../../pages/associateRegistration/AssociateTree';
import AssociateCommission from '../../pages/associateRegistration/AssociateCommision';
import EditCommission from '../../pages/associateRegistration/EditCommission';
import CommissionGenerate from '../../pages/commissionGenerate/CommissionGenrate';
import AssociateChange from '../../pages/associateRegistration/AssociateChange';
import AssociateTransfer from '../../pages/associateRegistration/AssociateTransfer';
import AssociateTransactionHistory from '../../pages/associateRegistration/AssociateTransactionHistory';
import MyTeam from '../../pages/associateRegistration/MyTeam';
import AssociateCredentials from '../../pages/associateRegistration/AssociateCredentials';


import Customer from '../../pages/members/Customer';
import CustomerForm from '../../pages/members/CustomerForm';
import CustomerHistory from '../../pages/members/CustomerHistory';
import AddLeadForm from '../../pages/members/AddLead';
import BulkImport from '../../pages/members/BulkImport';

import AddBooking from '../../pages/plotBooking/BookPlot';
import BookingDetail from '../../pages/plotBooking/BookingDetaila';
import BookingApproval from '../../pages/plotBooking/BookingApproval';
import BookingDetails from '../../pages/plotBooking/BookingDetails';
import ChangePaytmentPlan from '../../pages/plotBooking/ChangePaytmentPlan';
import TransferBooking from '../../pages/plotBooking/TransferBooking';
import ChangePlot from '../../pages/plotBooking/ChangePlot';
import HoldPlot from '../../pages/plotBooking/HoldPlot';
import PlotUnhold from '../../pages/plotBooking/PlotUnhold';
import AllotmentPayment from '../../pages/plotBooking/AllotmentPayment';
import InstallmentPayment from '../../pages/plotBooking/InstallmentPayment';
import PlotAvailability from '../../pages/plotBooking/PlotAvailability';
import CancelPlotBooking from '../../pages/plotBooking/CancelPlotBooking';
import PlotCancellationRequest from '../../pages/plotBooking/PlotCancellationRequest';
import CancleBooking from '../../pages/plotBooking/CancleBooking';
import RateConcession from '../../pages/plotBooking/RateConcession';
import RateConcessionApproval from '../../pages/plotBooking/RateConcessionApproval';
import PlotRegistry from '../../pages/plotBooking/PlotRegistry';
import AllowPayoutCommission from '../../pages/plotBooking/AllowPayoutCommission';
import PLCpayment from '../../pages/plotBooking/PLCpayment';
import ReceiptApproval from '../../pages/plotBooking/ReceiptApproval';


//User permission
import Employee from '../../pages/employee/Employee';
import FormTypeMaster from '../../pages/userPermission/FormTypeMaster';
import FormMaster from '../../pages/userPermission/FormMaster';
import RoleMaster from '../../pages/userPermission/RoleMaster';
import RolePermission from '../../pages/userPermission/RolePermission';
import SetPermission from '../../pages/userPermission/SetPermission';

//Team

import Direct from '../../pages/team/Direct';
import Downline from '../../pages/team/Downline';

// Retail Business
import ProductMaster from '../../pages/retailBusiness/retailMasterAll/ProductMaster';
import CategoryMaster from '../../pages/retailBusiness/retailMasterAll/CategoryMaster';
import BrandMaster from '../../pages/retailBusiness/retailMasterAll/BrandMaster';
import UnitMaster from '../../pages/retailBusiness/retailMasterAll/UnitMaster';
import TaxMaster from '../../pages/retailBusiness/retailMasterAll/TaxMaster';
import PriceListMaster from '../../pages/retailBusiness/retailMasterAll/PriceListMaster';
import DiscountMaster from '../../pages/retailBusiness/retailMasterAll/DiscountMaster';
import VendorSupplier from '../../pages/retailBusiness/retailMasterAll/VendorSupplier';
import StockInPurchaseEntry from '../../pages/retailBusiness/inventory/StockInPurchesEntry';
import StockOut from '../../pages/retailBusiness/inventory/StockOut';
import StockTransfer from '../../pages/retailBusiness/inventory/StockTrasfer';
import DamagedReturn from '../../pages/retailBusiness/inventory/DamagedReturn';
import LowStockAlert from '../../pages/retailBusiness/inventory/LowStockAlert';
import AddNewCustomer from '../../pages/retailBusiness/customer/AddNewCustomer';
import CustomerGroups from '../../pages/retailBusiness/customer/CustomerGroups';
import LoyaltyProgram from '../../pages/retailBusiness/customer/LoyaltyProgram';
import PartnerRegistration from '../../pages/retailBusiness/salePartner/PartnerRegistration';
import PartnerList from '../../pages/retailBusiness/salePartner/PartnerList';
import KYCVerification from '../../pages/retailBusiness/salePartner/KYCVerification';
import SalesCommissionSetup from '../../pages/retailBusiness/salePartner/SalesCommissionSetup';
import NewBilling from '../../pages/retailBusiness/Billing/NewBilling';
import InvoiceList from '../../pages/retailBusiness/Billing/InvoiceList';
import SalesReturn from '../../pages/retailBusiness/Billing/SalesReturn';
// import NewOrder from '../../pages/retailBusiness/orders/NewOrder';
import OrderList from '../../pages/retailBusiness/orders/OrderList';
import OrderDispatch from '../../pages/retailBusiness/orders/OrderDispatch';
import ReturnRefund from '../../pages/retailBusiness/orders/ReturnRefund';
import ExchangeReplacement from '../../pages/retailBusiness/orders/ExchangeReplacement';
import StoreMaster from '../../pages/retailBusiness/multiStore/StoreMaster';
import CentralizedStock from '../../pages/retailBusiness/multiStore/CentralizedStock';
import HQDashboard from '../../pages/retailBusiness/multiStore/HQDashboard';

// payout

import PayoutReport from '../../pages/payout/PayoutReport';
import PayoutReportForBank from '../../pages/payout/PayoutReportForBank';
import ConsolidatedPayoutReport from '../../pages/payout/ConsolidatedPayoutReport';
import UpdatePayoutPayment from '../../pages/payout/UpdatePayoutPayment';
import PayoutSummary from '../../pages/payout/PayoutSummary';
import TDSReport from '../../pages/payout/TDSReport';
import PaymentAssociate from '../../pages/paymentAssociate/PaymentAssociate';
import PayIncentive from '../../pages/paymentAssociate/PayIncentive';
import PaymentAssociateList from '../../pages/paymentAssociate/PaymentAssociateList';


// account 
import AdvancePayment from '../../pages/account/AdvancePayment';
import CancelledBooking from '../../pages/account/CancelledBooking';
import CancelledBookingRefundRequestList from '../../pages/account/CancelledBookingRefundRequestList';
import CancelledPlotRefund from '../../pages/account/CancelledPlotRefund';
import CashApproval from '../../pages/account/CashApproval';
import ChequeDDApproval from '../../pages/account/ChequeDDApproval';
import DayBookReport from '../../pages/account/DayBookReport';
import PaymentUpdate from '../../pages/account/PaymentUpdate';
import PaymentVoucher from '../../pages/account/PaymentVoucher';


// support
import PendingTickets from '../../pages/support/PendingTickets';
import CloseTickets from '../../pages/support/CloseTickets';
import QuickContactUs from '../../pages/support/QuickContactUs';


//purchase
import Purchase from '../../pages/purchase/Purchase.jsx'
import FarmerLedger from '../../pages/purchase/FarmerLedger.jsx';
import SellerList from '../../pages/purchase/SellerList.jsx';
import Announcement from '../../pages/announcement/Announcement';
import ActivityLog from '../../pages/activityLog/ActivityLog';
import Facebook from '../../pages/social/Facebook';
import Google from '../../pages/social/Google';
import Website from '../../pages/social/Website';
import Funnel from '../../pages/Funnel/Funnel';
import TotalDue from '../../pages/totalDue/TotalDue.jsx';



import BreadCrumbs from '../../components/BreadCrumbs';

// context
import { useLayoutState } from '../../context/LayoutContext';
import { ProductsProvider } from '../../context/ProductContext'

import UsersFormPage from 'pages/CRUD/Users/form/UsersFormPage';
import UsersTablePage from 'pages/CRUD/Users/table/UsersTablePage';

//Sidebar structure
import structure, { settingsSidebarStructure } from '../Sidebar/SidebarStructure'
import { getFilteredStructure } from '../../utils/menuFilter'
import { useUserState, useUserDispatch, signOut } from '../../context/UserContext';
import CreateRoles from '../../pages/roles/CreateRoles';
import EditRoles from '../../pages/roles/EditRoles';

// Permission helpers
const normalizePath = (p) => {
  const s = (p || '').toString().trim();
  if (!s) return '/';
  return s.replace(/\/+$/, '').toLowerCase();
};

const slugify = (s) =>
  String(s || '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

const makeModuleName = (groupLabel, itemLabel) => `${slugify(groupLabel)}.${slugify(itemLabel)}`;

const buildPathModuleIndex = (nodes, sectionLabel = null, rootGroup = null, lastGroupWithChildren = null, acc = []) => {
  (nodes || []).forEach((node) => {
    if (!node) return;
    const label = node.label || '';
    const hasChildren = Array.isArray(node.children) && node.children.length > 0;

    // Identify section (top-level with children) and root group (first child under a section)
    const nextSection = sectionLabel || (hasChildren ? label : null);
    const nextRootGroup = rootGroup || (sectionLabel ? label : null);
    const nextLastGroup = hasChildren ? label : lastGroupWithChildren;
    const isLeaf = !hasChildren;

    if (isLeaf && nextRootGroup && node.link) {
      const normalizedPath = normalizePath(node.link);
      const pathForIndex = normalizedPath.includes('/:') ? normalizedPath.split('/:')[0] : normalizedPath;

      const moduleName = node.permission
        ? node.permission.toLowerCase().trim()
        : makeModuleName(nextRootGroup, nextLastGroup && nextLastGroup !== nextRootGroup && nextLastGroup !== nextSection ? nextLastGroup : label);

      acc.push({ path: pathForIndex, module: moduleName });
    }

    if (hasChildren) {
      buildPathModuleIndex(node.children, nextSection, nextRootGroup, nextLastGroup, acc);
    }
  });
  return acc;
};

const PATH_MODULE_INDEX = buildPathModuleIndex(structure);

const findModuleForPath = (pathname) => {
  const normalized = normalizePath(pathname);
  let match = null;
  PATH_MODULE_INDEX.forEach(({ path, module }) => {
    if (!normalized.startsWith(path)) return;
    const hasBoundary = normalized.length === path.length || normalized[path.length] === '/';
    if (!hasBoundary) return;
    if (!match || path.length > match.path.length) {
      match = { path, module };
    }
  });
  return match?.module || null;
};

const getReadableModuleSet = (roleMaster) => {
  let modules =
    Array.isArray(roleMaster?.modules) && roleMaster.modules.length > 0
      ? roleMaster.modules
      : (() => {
        try {
          const raw = localStorage.getItem('roleModules');
          const parsed = raw ? JSON.parse(raw) : [];
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      })();

  // Handle case where roleMaster itself might be an array (due to API response format)
  if (!Array.isArray(modules) && Array.isArray(roleMaster) && roleMaster[0]?.modules) {
    modules = roleMaster[0].modules;
  }

  const set = new Set();
  if (Array.isArray(modules)) {
    modules.forEach((m) => {
      const name = (m?.name || m?.moduleName || '').toString().toLowerCase().trim();
      if (!name) return;
      const actionsRaw = m?.actions || m?.permissions;
      const actions = Array.isArray(actionsRaw)
        ? actionsRaw
        : typeof actionsRaw === 'string'
          ? [actionsRaw]
          : [];
      const hasRead = actions.some((a) => {
        const actionStr = String(a || '').toLowerCase().trim();
        return actionStr === 'read' || actionStr === 'view' || actionStr === 'all';
      });
      if (hasRead) set.add(name);
    });
  }
  return set;
};

const getWritableModuleSet = (roleMaster) => {
  let modules =
    Array.isArray(roleMaster?.modules) && roleMaster.modules.length > 0
      ? roleMaster.modules
      : (() => {
        try {
          const raw = localStorage.getItem('roleModules');
          const parsed = raw ? JSON.parse(raw) : [];
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      })();

  if (!Array.isArray(modules) && Array.isArray(roleMaster) && roleMaster[0]?.modules) {
    modules = roleMaster[0].modules;
  }

  const set = new Set();
  if (Array.isArray(modules)) {
    modules.forEach((m) => {
      const name = (m?.name || m?.moduleName || '').toString().toLowerCase().trim();
      if (!name) return;
      const actionsRaw = m?.actions || m?.permissions;
      const actions = Array.isArray(actionsRaw)
        ? actionsRaw
        : typeof actionsRaw === 'string'
          ? [actionsRaw]
          : [];
      const hasWrite = actions.some((a) => {
        const actionStr = String(a || '').toLowerCase().trim();
        return actionStr === 'write' || actionStr === 'edit' || actionStr === 'create' || actionStr === 'all';
      });
      if (hasWrite) set.add(name);
    });
  }
  return set;
};

const Redirect = (props) => {
  useEffect(() => window.location.replace(props.url));
  return <span>Redirecting...</span>;
};

function Layout(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { currentUser } = useUserState();
  const userDispatch = useUserDispatch();
  const { roleLoading, roleLoaded, isAuthenticated, user, logout, roleMaster } = useAuth();

  const open = Boolean(anchorEl);
  // OTP state
  const [isOtpOpen, setIsOtpOpen] = React.useState(false);
  const [hasVerifiedRoleAccess, setHasVerifiedRoleAccess] = React.useState(
    sessionStorage.getItem('isRoleModuleVerified') === 'true'
  );

  // global
  let layoutState = useLayoutState();

  const currentPath = props.location?.pathname?.toLowerCase() || '';
  const isRolesPath =
    currentPath.includes('/creteroles') ||
    currentPath.includes('/editroles') ||
    currentPath.includes('/userpermission/rolemaster') ||
    currentPath.includes('/userpermission/rolepermission') ||
    currentPath.includes('/userpermission/setpermission');

  React.useEffect(() => {
    if (isRolesPath && !hasVerifiedRoleAccess) {
      setIsOtpOpen(true);
    }
  }, [isRolesPath, hasVerifiedRoleAccess]);

  // Reset verification when navigating away from Roles section
  React.useEffect(() => {
    if (!isRolesPath && hasVerifiedRoleAccess) {
      sessionStorage.removeItem('isRoleModuleVerified');
      setHasVerifiedRoleAccess(false);
    }
  }, [isRolesPath, hasVerifiedRoleAccess, currentPath]);

  const handleOtpSuccess = () => {
    sessionStorage.setItem('isRoleModuleVerified', 'true');
    setHasVerifiedRoleAccess(true);
    // Modal will close automatically via setIsOtpOpen(false) in handleOtpClose if we rely on state
    setIsOtpOpen(false);
  };

  const handleOtpClose = (event, reason) => {
    // If user clicked backdrop or close button without success, send to dashboard
    if (reason !== 'success' && !sessionStorage.getItem('isRoleModuleVerified')) {
      props.history.push('/app/dashboard');
    }
    setIsOtpOpen(false);
  };

  const sidebarLoading = Boolean(isAuthenticated && (!roleLoaded || roleLoading));
  const filteredStructure = React.useMemo(() => {
    if (sidebarLoading) return structure;
    return getFilteredStructure(structure);
  }, [sidebarLoading, isAuthenticated]);

  const isForbidden = React.useMemo(() => {
    if (!isAuthenticated) return false;
    // Don't flag as forbidden yet while loading
    if (roleLoading || !roleLoaded) return false;

    const path = props.location?.pathname?.toLowerCase() || '';
    const roleName = (user?.role || '').toString().toLowerCase();

    // 1. Always allow superadmin
    if (roleName === 'superadmin') return false;

    // 2. Performance bypass for essential system paths
    if (path === '/app/dashboard' || path.startsWith('/app/profile/') || path.includes('/sitevisit/') || path.startsWith('/app/social/')) return false;

    // 3. Determine the functional module for this path
    let moduleName = findModuleForPath(props.location?.pathname || '');

    if (!moduleName) {
      if (path.includes('/creteroles') || path.includes('/editroles') || path.includes('/userpermission') || path.includes('/rolemaster')) {
        moduleName = 'user-management.create-roles';
      }
    }

    // Exception: admin always has permission for role management
    if (roleName === 'admin' && moduleName === 'user-management.create-roles') return false;

    // 4. Validate access against the user's permission set
    if (moduleName) {
      const readable = getReadableModuleSet(roleMaster);
      if (!readable.has(moduleName)) return true;

      // Check if this is a path that requires 'write' permission
      const isWritePath =
        path.includes('/add') ||
        path.includes('/edit') ||
        path.includes('/registration') ||
        path.includes('/change') ||
        path.includes('/transfer') ||
        path.includes('/bulk-import') ||
        path.includes('/creteroles') ||
        path.includes('/create') ||
        path.includes('/delete') ||
        path.includes('/payment') ||
        path.includes('/unhold') ||
        path.includes('/setpermission') ||
        path.includes('/editroles') ||
        path.includes('/rolemaster') ||
        path.includes('/userpermission');

      if (isWritePath) {
        const writable = getWritableModuleSet(roleMaster);
        if (!writable.has(moduleName)) return true;
      }
    }

    // 5. Default safety: If it's a known sensitive path but unmapped, block it
    if (path.includes('/creteroles') || path.includes('/userpermission')) {
      return true;
    }

    return false;
  }, [isAuthenticated, roleLoading, roleLoaded, user?.role, props.location?.pathname, roleMaster]);

  const forceLogoutForAccess = React.useCallback((redirectPath = '/login') => {
    // Clear both auth contexts to fully sign out and send user back to login
    try {
      logout();
    } catch { }
    try {
      signOut(userDispatch, props.history, redirectPath);
    } catch {
      try {
        props.history.replace(redirectPath);
      } catch {
        window.location.replace(redirectPath);
      }
    }
  }, [logout, props.history, userDispatch]);

  const isSettingPage = props.location.pathname.startsWith('/app/setting');
  const isFullWidthPage = props.location.pathname === '/app/setting/level-structure';
  const sidebarContent = isSettingPage ? settingsSidebarStructure : filteredStructure;

  return (
    <div className={classes.root}>
      <Header history={props.history} />
      {!isFullWidthPage && <Sidebar structure={sidebarContent} loading={sidebarLoading} />}
      <div
        className={classnames(classes.content, {
          [classes.contentShift]: layoutState.isSidebarOpened && !isFullWidthPage,
        })}
        style={isFullWidthPage ? { width: '100vw', margin: 0 } : {}}
      >
        <div className={classes.fakeToolbar} />
        {/* <BreadCrumbs /> */}
        {isForbidden ? (
          <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', textAlign: 'center' }}>
            <Paper elevation={0} sx={{ p: { xs: 4, md: 8 }, borderRadius: 4, backgroundColor: '#fff5f5', border: '1px dashed #feb2b2', maxWidth: 600 }}>
              <Avatar sx={{ bgcolor: '#feb2b2', width: 80, height: 80, mb: 3, mx: 'auto' }}>
                <LockIcon sx={{ fontSize: 40, color: '#c53030' }} />
              </Avatar>
              <MuiTypography variant="h4" fontWeight="bold" color="#c53030" gutterBottom>
                Access Denied
              </MuiTypography>
              <MuiTypography variant="body1" color="text.secondary" sx={{ mb: 4, fontSize: '1.1rem' }}>
                You do not have permission to access the <strong>{props.location.pathname.split('/').pop().replace(/([A-Z])/g, ' $1').trim()}</strong> module.
                {/* Please contact your administrator to request access for your profile. */}
              </MuiTypography>
              <MuiButton
                variant="contained"
                onClick={() => props.history.push('/app/dashboard')}
                sx={{
                  backgroundColor: '#c53030',
                  color: '#white',
                  '&:hover': { backgroundColor: '#9b2c2c' },
                  borderRadius: 2,
                  px: 4,
                  py: 1.5,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 'bold'
                }}
              >
                Back to Dashboard
              </MuiButton>
            </Paper>
          </Box>
        ) : (roleLoading && !roleLoaded) ? (
          // Wait for role data to arrive before mounting sub-components to prevent unauthorized API calls
          <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '70vh' }} />
        ) : (
          <Switch>
            <Route path='/app/dashboard' component={Dashboard} />

            {/* OTP Protection for Roles */}
            {isRolesPath && !hasVerifiedRoleAccess ? (
              <Route path="*" render={() => (
                <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', textAlign: 'center' }}>
                  <Paper elevation={0} sx={{ p: { xs: 4, md: 8 }, borderRadius: 4, backgroundColor: '#f0f7ff', border: '1px dashed #536DFE', maxWidth: 600 }}>
                    <Avatar sx={{ bgcolor: '#536DFE', width: 80, height: 80, mb: 3, mx: 'auto' }}>
                      <LockIcon sx={{ fontSize: 40, color: 'white' }} />
                    </Avatar>
                    <MuiTypography variant="h4" fontWeight="bold" color="#536DFE" gutterBottom>
                      Verification Required
                    </MuiTypography>
                    <MuiTypography variant="body1" color="text.secondary" sx={{ mb: 4, fontSize: '1.1rem' }}>
                      Please complete OTP verification to access <strong>Roles Management</strong>.
                    </MuiTypography>
                    <MuiButton
                      variant="contained"
                      onClick={() => setIsOtpOpen(true)}
                      sx={{
                        backgroundColor: '#536DFE',
                        color: 'white',
                        '&:hover': { backgroundColor: '#3d5afe' },
                        borderRadius: 2,
                        px: 4,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: '1rem',
                        fontWeight: 'bold'
                      }}
                    >
                      Verify Identity
                    </MuiButton>
                    <MuiButton
                      variant="text"
                      onClick={() => props.history.push('/app/dashboard')}
                      sx={{
                        mt: 2,
                        textTransform: 'none',
                        color: 'text.secondary'
                      }}
                    >
                      Back to Dashboard
                    </MuiButton>
                  </Paper>
                </Box>
              )} />
            ) : null}

            <Route path='/app/dashboard' component={Dashboard} />
            {/* Roles */}
            <Route path={'/app/creteRoles'} exact component={CreateRoles} />
            <Route path={'/app/editRoles/:id?'} exact component={EditRoles} />
            {/* <Route path='/app/user/edit' component={EditUser} /> */}

            <Route path={'/app/users/MyTeam'} exact component={MyTeam} />




            <Route path="/app/ecommerce/generalMaster" component={GeneralMaster} />
            <Route path="/app/setting/reward" component={RewardSetting} />
            <Route path="/app/setting/commission" component={CommissionSetting} />
            <Route path="/app/setting/incentive" component={IncentiveSetting} />
            <Route path="/app/setting/level-structure" component={LevelStructure} />
            <Route path="/app/achievements/my-reward" component={MyRewardIncentive} />
            <Route path="/app/achievements/my-incentive" component={MyRewardIncentive} />
            <Route path="/app/announcement" component={Announcement} />
            <Route path="/app/activity-logs" component={ActivityLog} />
            <Route path="/app/social/facebook" component={Facebook} />
            <Route path="/app/social/google" component={Google} />
            <Route path="/app/social/website" component={Website} />
            <Route path="/app/funnel" component={Funnel} />



            {/* Organization Master */}
            <Route path="/app/organization/Policy" component={Policy} />
            <Route path="/app/organization/OrganizationProfile" component={OrganizationProfile} />
            <Route path="/app/organization/DesignationSetup" component={DesignationSetup} />
            <Route path="/app/organization/DepartmentSetup" component={DepartmentSetup} />
            <Route path="/app/organization/Business" component={BusinessSetup} />
            <Route path="/app/organization/BranchSetup" component={BranchSetup} />

            <Route path={'/app/users/AssociateList'} exact component={AssociateList} />
            <Route path={'/app/users/AssociateCredentials'} exact component={AssociateCredentials} />
            <Route path={'/app/user/AssociateEdit/:associatedId'} exact component={AssociateListEditable} />
            <Route path={'/app/user/AssociateRegistration'} exact component={AssociateRegistration} />
            <Route path={'/app/users/AssociateTree'} exact component={AssociateTree} />
            <Route path={'/app/users/AssociateCommission'} exact component={AssociateCommission} />
            <Route path={'/app/users/AssociateCommission/edit'} exact component={EditCommission} />
            <Route path={'/app/commissionGenerate/CommissionGenerate'} exact component={CommissionGenerate} />
            <Route path={'/app/user/AssociateChange'} exact component={AssociateChange} />
            <Route path={'/app/user/AssociateTransfer'} exact component={AssociateTransfer} />
            <Route path={'/app/user/AssociateTransactionHistory/:id'} exact component={AssociateTransactionHistory} />


            <Route path={'/app/profile/myProfile'} exact component={MyProfile} />
            <Route path={'/app/profile/myBusiness'} exact component={MyBusiness} />
            <Route path={'/app/profile/changeSponsor'} exact component={ChangeSponsor} />
            <Route path={'/app/profile/kycApproval'} exact component={KYCApproval} />
            <Route path={'/app/profile/paymentHistory'} exact component={MyHistory} />

            {/* Lead Routes */}
            <Route path={'/app/lead/LeadList'} exact component={LeadList} />
            <Route path={'/app/lead/AddLead'} exact component={AddLead} />
            <Route path={'/app/lead/EditLead'} exact component={EditLead} />
            <Route path={'/app/lead/AddVisit'} exact component={AddVisit} />
            <Route path={'/app/lead/LeadTimeline'} exact component={LeadTimeLine} />
            <Route path={'/app/lead/ChangeAssociate'} exact component={ChangeAssociate} />
            <Route path={'/app/lead/TransferHistory'} exact component={TransferHistory} />
            <Route path={'/app/lead/TransferProcess'} component={TransferProcess} />

            {/* Site Visit Routes */}
            <Route path={'/app/siteVisit/SiteVisit'} exact component={SiteVisit} />
            <Route path={'/app/siteVisit/AddSiteVisit'} exact component={AddSiteVisit} />
            <Route path={'/app/siteVisit/SiteVisitTimeline'} exact component={SiteVisitTimeline} />

            {/* Project Routes */}
            <Route path={'/app/project/ProjectList'} exact component={ProjectList} />
            <Route path={'/app/project/add'} exact component={ProjectForm} />
            <Route path={'/app/project/edit'} exact component={ProjectForm} />
            <Route path={'/app/project/details'} exact component={ProjectDetails} />
            <Route path={'/app/project/PlotListDetails'} exact component={PlotListDetails} />
            <Route path={'/app/project/plot/add'} exact component={PlotForm} />
            <Route path={'/app/project/plot/edit'} exact component={PlotForm} />
            <Route path={'/app/project/PlotInventory'} exact component={PlotInventory} />
            <Route path={'/app/project/ProjectPricing'} exact component={ProjectPricing} />
            <Route path={'/app/project/apartment/buildings'} exact component={BuildingList} />
            <Route path={'/app/project/apartment/building/add'} exact component={BuildingForm} />
            <Route path={'/app/project/apartment/building/edit/:id'} exact component={BuildingForm} />
            <Route path={'/app/project/apartment/floors'} exact component={FloorList} />
            <Route path={'/app/project/apartment/floor/add'} exact component={FloorForm} />
            <Route path={'/app/project/apartment/floor/edit/:id'} exact component={FloorForm} />
            <Route path={'/app/project/apartment/flats'} exact component={FlatList} />
            <Route path={'/app/project/apartment/flat/add'} exact component={FlatForm} />
            <Route path={'/app/project/apartment/flat/edit/:id'} exact component={FlatForm} />
            <Route path={'/app/project/ProjectEnquiry'} exact component={ProjectEnquiry} />
            <Route path={'/app/project/villa/add'} exact component={VillaForm} />
            <Route path={'/app/project/villa/edit'} exact component={VillaForm} />
            <Route path={'/app/project/rowhouse'} exact component={RowHouse} />
            <Route path={'/app/project/rowhouse/add'} exact component={RowHouseForm} />
            <Route path={'/app/project/rowhouse/edit'} exact component={RowHouseForm} />

            {/* Inventory Route */}
            <Route path={'/app/inventory'} exact component={Inventory} />

            {/* Apartment Routes */}
            <Route path={'/app/project/apartment/add'} exact component={ApartmentForm} />
            <Route path={'/app/project/apartment/edit'} exact component={ApartmentEdit} />
            <Route path={'/app/project/apartment/details'} exact component={ApartmentDetails} />

            <Route path={'/app/members/customer/add'} exact component={CustomerForm} />
            <Route path={'/app/members/customer/edit'} exact component={CustomerForm} />
            <Route path={'/app/members/customer/add-lead'} exact component={AddLeadForm} />
            <Route path={'/app/members/customer/history'} exact component={CustomerHistory} />
            <Route path={'/app/members/Customer'} exact component={Customer} />
            <Route path={'/app/due/TotalDue'} exact component={TotalDue} />
            <Route path={'/app/members/customer/bulk-import'} exact component={BulkImport} />
            <Route path={'/app/members/leads/bulk-import'} exact component={BulkImport} />
            <Route path={'/app/siteVisit/bulk-import'} exact component={BulkImport} />
            <Route path={'/app/users/AssociateList/bulk-import'} exact component={BulkImport} />



            <Route path={'/app/booking/AddBooking'} exact component={AddBooking} />
            <Route path={'/app/booking/BookingDetail'} exact component={BookingDetail} />
            <Route path={'/app/plotbooking/CancleBooking'} exact component={CancleBooking} />
            <Route path={'/app/booking/BookingApproval'} exact component={BookingApproval} />
            <Route path={'/app/booking/ReceiptApproval'} exact component={ReceiptApproval} />
            <Route path={'/app/booking/BookingDetails/:id'} exact component={BookingDetails} />
            <Route path={'/app/plotbooking/ChangePaytmentPlan'} exact component={ChangePaytmentPlan} />
            <Route path={'/app/plotbooking/TransferBooking'} exact component={TransferBooking} />
            <Route path={'/app/plotbooking/ChangePlot'} exact component={ChangePlot} />
            <Route path={'/app/plotbooking/HoldPlot'} exact component={HoldPlot} />
            <Route path={'/app/plotbooking/PlotUnhold'} exact component={PlotUnhold} />
            <Route path={'/app/plotbooking/AllotmentPayment'} exact component={AllotmentPayment} />
            <Route path={'/app/plotbooking/InstallmentPayment'} exact component={InstallmentPayment} />
            <Route path={'/app/plotbooking/PlotAvailability'} exact component={PlotAvailability} />
            <Route path={'/app/plotbooking/CancelPlotBooking'} exact component={CancelPlotBooking} />
            <Route path={'/app/plotbooking/PlotCancellationRequest'} exact component={PlotCancellationRequest} />
            <Route path={'/app/plotbooking/RateConcession'} exact component={RateConcession} />
            <Route path={'/app/plotbooking/RateConcessionApproval'} exact component={RateConcessionApproval} />
            <Route path={'/app/plotbooking/PlotRegistry'} exact component={PlotRegistry} />
            <Route path={'/app/plotbooking/AllowPayoutCommission'} exact component={AllowPayoutCommission} />
            <Route path={'/app/plotbooking/PLCpayment'} exact component={PLCpayment} />

            {/* purchase */}
            <Route path={'/app/Purchase/farmer'} component={Purchase} />
            <Route path={'/app/Purchase/seller'} component={SellerList} />
            <Route path={'/app/Purchase/FarmerLedger'} component={FarmerLedger} />



            {/*User permission*/}
            <Route path={'/app/employee/Employee'} exact component={Employee} />
            <Route path={'/app/userpermission/FormTypeMaster'} exact component={FormTypeMaster} />
            <Route path={'/app/userpermission/FormMaster'} exact component={FormMaster} />
            <Route path={'/app/userpermission/RoleMaster'} exact component={RoleMaster} />
            <Route path={'/app/userpermission/RolePermission'} exact component={RolePermission} />
            <Route path={'/app/userpermission/SetPermission'} exact component={SetPermission} />


            {/*Team*/}
            <Route path={'/app/teams/Direct'} exact component={Direct} />
            <Route path={'/app/teams/Downline'} exact component={Downline} />

            {/* Retail Business */}
            <Route path={'/app/retailBusiness/ProductMaster'} exact component={ProductMaster} />
            <Route path={'/app/retailBusiness/CategoryMaster'} exact component={CategoryMaster} />
            <Route path={'/app/retailBusiness/BrandMaster'} exact component={BrandMaster} />
            <Route path={'/app/retailBusiness/UnitMaster'} exact component={UnitMaster} />
            <Route path={'/app/retailBusiness/TaxMaster'} exact component={TaxMaster} />
            <Route path={'/app/retailBusiness/PriceListMaster'} exact component={PriceListMaster} />
            <Route path={'/app/retailBusiness/DiscountMaster'} exact component={DiscountMaster} />
            <Route path={'/app/retailBusiness/VendorSupplier'} exact component={VendorSupplier} />
            <Route path={'/app/retailBusiness/StockInPurchaseEntry'} exact component={StockInPurchaseEntry} />
            <Route path={'/app/retailBusiness/StockOut'} exact component={StockOut} />
            <Route path={'/app/retailBusiness/StockTransfer'} exact component={StockTransfer} />
            <Route path={'/app/retailBusiness/DamagedReturn'} exact component={DamagedReturn} />
            <Route path={'/app/retailBusiness/LowStockAlert'} exact component={LowStockAlert} />
            <Route path={'/app/retailBusiness/AddNewCustomer'} exact component={AddNewCustomer} />
            <Route path={'/app/retailBusiness/CustomerGroups'} exact component={CustomerGroups} />
            <Route path={'/app/retailBusiness/LoyaltyProgram'} exact component={LoyaltyProgram} />
            <Route path={'/app/retailBusiness/PartnerRegistration'} exact component={PartnerRegistration} />
            <Route path={'/app/retailBusiness/PartnerList'} exact component={PartnerList} />
            <Route path={'/app/retailBusiness/KYCVerification'} exact component={KYCVerification} />
            <Route path={'/app/retailBusiness/SalesCommissionSetup'} exact component={SalesCommissionSetup} />
            <Route path={'/app/retailBusiness/NewBilling'} exact component={NewBilling} />
            <Route path={'/app/retailBusiness/InvoiceList'} exact component={InvoiceList} />
            <Route path={'/app/retailBusiness/SalesReturn'} exact component={SalesReturn} />
            {/* <Route path={'/app/retailBusiness/NewOrder'} exact component={NewOrder} /> */}
            <Route path={'/app/retailBusiness/OrderList'} exact component={OrderList} />
            <Route path={'/app/retailBusiness/OrderDispatch'} exact component={OrderDispatch} />
            <Route path={'/app/retailBusiness/ReturnRefund'} exact component={ReturnRefund} />
            <Route path={'/app/retailBusiness/ExchangeReplacement'} exact component={ExchangeReplacement} />
            <Route path={'/app/retailBusiness/StoreMaster'} exact component={StoreMaster} />
            <Route path={'/app/retailBusiness/CentralizedStock'} exact component={CentralizedStock} />
            <Route path={'/app/retailBusiness/HQDashboard'} exact component={HQDashboard} />

            {/* payout */}
            <Route path={'/app/payout/PayoutReport'} exact component={PayoutReport} />
            <Route path={'/app/payout/PayoutReportForBank'} exact component={PayoutReportForBank} />
            <Route path={'/app/payout/ConsolidatedPayoutReport'} exact component={ConsolidatedPayoutReport} />
            <Route path={'/app/payout/UpdatePayoutPayment'} exact component={UpdatePayoutPayment} />
            <Route path={'/app/payout/PayoutSummary'} exact component={PayoutSummary} />
            <Route path={'/app/payout/TDSReport'} exact component={TDSReport} />
            <Route path={'/app/payment-associate'} exact component={PaymentAssociate} />
            <Route path={'/app/PaymentAssociate'} exact component={PaymentAssociate} />
            <Route path={'/app/pay-incentive'} exact component={PayIncentive} />
            <Route path={'/app/paymentAssociate/List'} exact component={PaymentAssociateList} />

            {/* account */}
            <Route path={'/app/account/AdvancePayment'} exact component={AdvancePayment} />
            <Route path={'/app/account/CancelledBooking'} exact component={CancelledBooking} />
            <Route path={'/app/account/CancelledBookingRefundRequestList'} exact component={CancelledBookingRefundRequestList} />
            <Route path={'/app/account/CancelledPlotRefund'} exact component={CancelledPlotRefund} />
            <Route path={'/app/account/CashApproval'} exact component={CashApproval} />
            <Route path={'/app/account/ChequeDDApproval'} exact component={ChequeDDApproval} />
            <Route path={'/app/account/DayBookReport'} exact component={DayBookReport} />
            <Route path={'/app/account/PaymentUpdate'} exact component={PaymentUpdate} />
            <Route path={'/app/account/PaymentVoucher'} exact component={PaymentVoucher} />

            {/* reports */}
            <Route path={'/app/reports/BusinessSummaryReport'} exact component={BusinessSummaryReport} />
            <Route path={'/app/reports/CommissionReport'} exact component={CommissionReport} />
            <Route path={'/app/reports/FollowupReport'} exact component={FollowupReport} />
            <Route path={'/app/reports/BookingReport'} exact component={BookingReport} />
            <Route path={'/app/reports/BookingCommission'} exact component={BookingCommission} />
            <Route path={'/app/reports/BookingReceipt'} exact component={BookingReceipt} />
            <Route path={'/app/reports/CustomerLedger'} exact component={CustomerLedger} />
            <Route path={'/app/reports/AssociateLedger'} exact component={AssociateLedger} />
            <Route path={'/app/reports/TDS'} exact component={TDS} />
            <Route path={'/app/reports/BranchWiseSummary'} exact component={BranchWiseSummary} />
            <Route path={'/app/reports/BranchSummaryDetails'} exact component={BranchSummaryDetails} />
            <Route path={'/app/reports/LeadReport'} exact component={LeadReport} />
            <Route path={'/app/reports/EMIReport'} exact component={EMIReport} />
            <Route path={'/app/reports/CancelReport'} exact component={CancelReport} />
            <Route path={'/app/reports/ProjectReport'} exact component={ProjectReport} />
            <Route path={'/app/reports/VisitSiteReport'} exact component={VisitSiteReport} />
            <Route path={'/app/adminPayment'} exact component={AdminPayment} />

            {/* Green Energy Management */}
            <Route path={'/app/green-energy/workflow'} exact component={WorkFlow} />
            <Route path={'/app/green-energy/capacity'} exact component={Capacity} />
            <Route path={'/app/green-energy/brand'} exact component={Brand} />
            <Route path={'/app/green-energy/installation-type'} exact component={InstallationType} />
            <Route path={'/app/green-energy/charger-type'} exact component={ChargerType} />
            <Route path={'/app/green-energy/project/create'} exact component={CreateProjectOrder} />
            <Route path={'/app/green-energy/project/assign-team'} exact component={AssignTeam} />
            <Route path={'/app/green-energy/project/progress-tracking'} exact component={ProgressTracking} />
            <Route path={'/app/green-energy/project/documents'} exact component={Documents} />
            <Route path={'/app/green-energy/project/attachments/add'} exact component={AddAttachment} />
            <Route path={'/app/green-energy/project/report'} exact component={GreenEnergyProjectReport} />

            {/* Green Energy Installation / Services */}
            <Route path={'/app/green-energy/service/request-list'} exact component={ServiceRequestList} />
            <Route path={'/app/green-energy/service/assign-technician'} exact component={AssignTechnicianInstallation} />
            <Route path={'/app/green-energy/service/installation-status'} exact component={InstallationStatus} />
            <Route path={'/app/green-energy/service/amc-schedule'} exact component={AMCSchedule} />
            <Route path={'/app/green-energy/service/amc-schedule/create'} exact component={AMCScheduleCreate} />
            <Route path={'/app/green-energy/service/feedback'} exact component={ServiceFeedback} />

            {/* support */}
            <Route path={'/app/support/PendingTickets'} exact component={PendingTickets} />
            <Route path={'/app/support/CloseTickets'} exact component={CloseTickets} />
            <Route path={'/app/support/QuickContactUs'} exact component={QuickContactUs} />

            {/* Reward Routes */}
            <Route path={'/app/promotion/reward-list'} exact component={PromotionRewardList} />
            <Route path={'/app/promotion/level-reward'} exact component={LevelAward} />
            <Route path={'/app/promotion/incentive'} exact component={Incentive} />
            <Route path={'/app/promotion/reward-approve'} exact component={RewardApprove} />
            <Route path={'/app/promotion/incentive-approve'} exact component={IncentiveApprove} />
            <Route path={'/app/reward/add-reward'} exact component={AddReward} />
            <Route path={'/app/reward/redeem-requests'} exact component={RedeemRequests} />
            <Route path={'/app/reward/reward-settings'} exact component={RewardSettings} />
            <Route path={'/app/reward/reward-category'} exact component={RewardCatorgy} />
            <Route path={'/app/reward/history-reward'} exact component={HistoryReward} />
            <Route path={'/app/associate-reward'} exact component={AssociateReward} />
            <Route path={'/app/reward/reward-transaction'} exact component={RewardTransaction} />
            <Route path={'/app/reward/reward-approve'} exact component={RewardApprove} />
            {/* 
          <Route path={'/app/users'} exact component={UsersTablePage} />
          <Route path={'/app/user/new'} exact component={UsersFormPage} />
          <Route
            path={'/app/users/:id/edit'}
            exact
            component={UsersFormPage}
          /> */}


          </Switch>
        )}
      </div>

      <OTPVerificationModal
        open={isOtpOpen}
        onClose={handleOtpClose}
        onSuccess={handleOtpSuccess}
        reason="accessing Role Management"
      />

      <Fab
        color='primary'
        aria-label='settings'
        onClick={(e) => setAnchorEl(open ? null : e.currentTarget)}
        className={classes.changeThemeFab}
        style={{ zIndex: 100 }}
      >
        <SettingsIcon style={{ color: '#fff' }} />
      </Fab>
      <ColorChangeThemePopper id={open ? 'add-section-popover' : undefined} open={open} anchorEl={anchorEl} />
    </div>
  );
}

export default withRouter(connect()(Layout));
